import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import StoreLocatorResultItem from './StoreLocatorResultItem';
import { groupStoresByType, toStoreEntry } from './helpers';
const Section = t0 => {
  const $ = _c(12);
  const {
    title,
    items,
    onActivate
  } = t0;
  if (!items || items.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== title) {
    t1 = <h2 className="text-lg text-gray font-bold mb-2">{title}</h2>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== items || $[3] !== onActivate) {
    let t3;
    if ($[5] !== onActivate) {
      t3 = (entry, idx) => <StoreLocatorResultItem key={entry.store.id} store={entry.store} index={idx + 1} onActivate={onActivate} />;
      $[5] = onActivate;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = items.map(t3);
    $[2] = items;
    $[3] = onActivate;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div>{t2}</div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t3) {
    t4 = <div className="mb-6">{t1}{t3}</div>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
Section.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  onActivate: PropTypes.func
};
const StoreLocatorResultsList = t0 => {
  const $ = _c(13);
  const {
    stores,
    onActivate
  } = t0;
  let showroomEntries;
  let t1;
  if ($[0] !== stores) {
    const seenStoreIds = new Set();
    const entries = (stores || []).map(toStoreEntry).filter(entry => {
      if (!entry || !entry.store || entry.store.id == null) {
        return false;
      }
      if (seenStoreIds.has(entry.store.id)) {
        return false;
      }
      seenStoreIds.add(entry.store.id);
      return true;
    });
    const {
      showrooms,
      partnerStudios
    } = groupStoresByType(entries.map(_temp));
    showroomEntries = entries.filter(e_0 => showrooms.some(s => s.id === e_0.store.id));
    t1 = entries.filter(e_1 => partnerStudios.some(s_0 => s_0.id === e_1.store.id));
    $[0] = stores;
    $[1] = showroomEntries;
    $[2] = t1;
  } else {
    showroomEntries = $[1];
    t1 = $[2];
  }
  const partnerEntries = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="text-sm text-gray-light2 mb-2">Showroom(s) within 50 miles</div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onActivate || $[5] !== showroomEntries) {
    t3 = <Section title="Joybird Showroom" items={showroomEntries} onActivate={onActivate} />;
    $[4] = onActivate;
    $[5] = showroomEntries;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onActivate || $[8] !== partnerEntries) {
    t4 = <Section title="Joybird Partner Studio" items={partnerEntries} onActivate={onActivate} />;
    $[7] = onActivate;
    $[8] = partnerEntries;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <div data-xc="StoreLocatorResultsList">{t2}{t3}{t4}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
StoreLocatorResultsList.propTypes = {
  stores: PropTypes.array.isRequired,
  onActivate: PropTypes.func
};
export default StoreLocatorResultsList;
function _temp(e) {
  return e.store;
}